import React from 'react'
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom'
//screens
import Login from 'screens/Welcome/Login'
import Register from 'screens/Welcome/Register'
import ForgotPassword from 'screens/Welcome/ForgotPassword'
import Dance from 'screens/Dance'
import Main from 'screens/Main'
import UserDances from 'screens/MyDances'
import UserPendingDancesRequests from 'screens/UserPendingDancesRequests'
import AdvancedSearch from 'screens/AdvancedSearch'
import AuthProtection from './AuthProtection.js'
import AllMediaRequests from 'screens/AllMediaRequests.js'
import Profile from 'screens/Profile.js'

const navigationRouter = (
    <Router>
        <Routes>
            <Route path="/" element={<Main />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgotPassword" element={<ForgotPassword />} />
            <Route
                path="/advancedSearch"
                element={<AuthProtection WrappedComponent={AdvancedSearch} />}
            />
            <Route
                path="/myDances"
                element={<AuthProtection WrappedComponent={UserDances} />}
            />
            <Route
                path="/myRequests/:choreographerId?"
                element={
                    <AuthProtection
                        WrappedComponent={UserPendingDancesRequests}
                    />
                }
            />
            <Route path="/allMediaRequests" element={<AllMediaRequests />} />
            <Route path="/dance/:danceId" element={<Dance />} />
            <Route path="/profile" element={<Profile />} />
        </Routes>
    </Router>
)

const NavigationRouter = () => {
    return <div>{navigationRouter}</div>
}

export default NavigationRouter
